export default "/packs/images/ta-new@2x~727a4d0579ec7ea8e868e454aa48a394.png";